module.exports = __webpack_public_path__ + "media/media/cases/rosneft/vyacheslav-cb3065f2065507c7c05d6e4835c47339.jpg";